export default "__VITE_PUBLIC_ASSET__0fb573e3__"